<div class="domainselect" id="hoverOnLeftPanel">
    <select id="dropDownForDomainsSection" name="recordList" class="select-wrapper"  (change)="onDomainChange($event)" [disabled]="changeDropdownView()">
        <ng-container *ngFor="let domains of userDomains">
      <option [selected]="domains.id == selectedDomain" [value]="domains.id">{{domains.name}}</option>
      
    </ng-container>
    </select>
  </div>
<ul class="menuContent vertical-nav">
  <ng-container *ngFor="let button of buttons">
    <li *ngIf="button.enable && button.name !== 'Trends'" (click)="leftMenuButtonClick(button)" [class]="button.class" id="{{button.class}}Link" routerLinkActive="{{button.router_link ? 'active': ''}}" [routerLink]="button.router_link ? button.router_link: ''">
      <i [class]="button.alternateClass" [id]="button.alternateClass"></i>
      <span [id]="button.alternateClass+'id' | lowercase" [innerHTML]="button.name"></span>
    </li>
    <li  tabindex="0"  class="allCards" id="allCardsLink" *ngIf="(isEnableGoogleTrends || isEnableCompitionData || isEnableTwitterTrend )&&button.name === 'Trends'">
      <div class="accordion">
        <input type="checkbox" class="acord" id="tab1">
        <label class="accordion-label" for="tab1">
          <i  class="icon-stocks1" style="margin-top:2px" ></i>
          <span class="accor_link">Trends</span> <i class="arrow down"></i></label>
        <div class="accordion-content">
          <div class="submenu_accord">
            <span *ngIf="isEnableTwitterTrend" [routerLink]="'./trends/twitterTrends'" routerLinkActive="{{'./trends/twitterTrends' ? 'active': ''}}">Twitter Trends</span>
            <span *ngIf="isEnableGoogleTrends" [routerLink]="'./trends/google-trends'" routerLinkActive="{{'./trends/google-trends' ? 'active': ''}}">Google Trends</span>
            <span *ngIf="isEnableCompitionData" [routerLink]="'./trends/competition-data'" routerLinkActive="{{'./trends/competition-data' ? 'active': ''}}">Competition Data</span>
          </div> 
        </div>
      </div>
    </li>
  </ng-container>
  <li  tabindex="0"  class="allCards" id="allCardsLink" *ngIf="isEnableStockModule || isEnableCricketAutoLiveBlog">
    <div class="accordion">
      <input type="checkbox" class="acord" id="tab1">
      <label class="accordion-label" for="tab1">
        <i  class="icon-cards" style="margin-top:2px" ></i>
        <span class="accor_link">Misc</span> <i class="arrow down"></i></label>
      <div class="accordion-content">
        <div class="submenu_accord">
          <span  *ngIf="isEnableStockModule" [routerLink]="'./misc/stock'" routerLinkActive="{{'./misc/stock' ? 'active': ''}}"><i  class="icon-stocks" ></i>Stocks</span>
        </div> 
      </div>
      <div class="accordion-content">
        <div class="submenu_accord">
          <span  *ngIf="isEnableCricketAutoLiveBlog" [routerLink]="'./misc/cricket'" routerLinkActive="{{'./misc/cricket' ? 'active': ''}}"><i  class="icon-stocks" ></i>Cricket</span>
        </div> 
      </div>
    </div>
  </li>
</ul>
<div class="userProfile">
  <div class="userName spImg">
    <span class="shortname">
      <ng-container *ngIf="profileImageUrl && (profileImageUrl !== '')">
        <img [src]="profileImageUrl">
      </ng-container>
      <ng-container *ngIf="!profileImageUrl || (profileImageUrl === '')">
        {{inits}}
      </ng-container>
    </span>
    <span id="userNameLabelAfterLogin" class="displayname">
      {{name}}
      <span class="userrole">[{{role | titlecase}}]</span>
    </span>
    <div class="userprofileBlock">
      <ul class="profileOption">
        <li class="logout"><a href="/login"> <i class="icon-logout"></i><span id="singOutButton">Logout</span></a></li>
      </ul>
    </div>
  </div>
</div>